/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { OSKUserOrganization } from '@oskey/core/types';
import { OSKSideMenu } from '../types/side-menus.type';
import { OSKSideMenuItem } from '../types/side-menu-item.type';

const adminDefaultMenuItems: OSKSideMenuItem[] = [
  {
    routerLink: '/pending-organizations',
    label: 'portals.sidemenu.admin.pendingOrganizations',
    icon: 'building',
    userRoles: ['v1.admin', 'v1.admin.org.admin']
  },
  {
    routerLink: '/oskey-users',
    label: 'portals.sidemenu.admin.admins',
    icon: 'users',
    userRoles: [
      'v1.admin.user.admin',
      'v1.admin.user.devices.admin',
      'v1.admin.user.invitations.admin',
      'v1.admin.user.accesses.admin'
    ]
  },
  {
    routerLink: '/pmp-users',
    label: 'portals.sidemenu.admin.users',
    icon: 'users',
    userRoles: [
      'v1.admin.user.admin',
      'v1.admin.user.devices.admin',
      'v1.admin.user.invitations.admin',
      'v1.admin.user.accesses.admin'
    ]
  },

  {
    routerLink: '/users',
    label: 'portals.sidemenu.admin.allUsers',
    icon: 'users',
    userRoles: [
      'v1.admin.user.admin',
      'v1.admin.user.devices.admin',
      'v1.admin.user.invitations.admin',
      'v1.admin.user.accesses.admin'
    ]
  },
  {
    routerLink: '/scripts',
    label: 'portals.sidemenu.admin.scripts',
    icon: 'file-text',
    userRoles: [
      'v1.admin.user.admin',
      'v1.admin.user.devices.admin',
      'v1.admin.user.invitations.admin',
      'v1.admin.user.accesses.admin'
    ]
  }
  // {
  //   label: 'portals.sidemenu.admin.organizationDivider',
  //   isDivider: true
  // },
];

/**
 * Generates the "Admin portal" default menu based on the user's roles
 *
 * @param userOrganization The user organization for which we are generating the menu
 * @returns {OSKSideMenu} The generated sidemenu
 */
export function generateOskeyAdminDefaultMenu(userOrganization: OSKUserOrganization): OSKSideMenu {
  const defaultMenu: OSKSideMenu = {
    items: []
  };

  if (userOrganization.userRoles.includes('v1.admin')) {
    defaultMenu.items.push(...adminDefaultMenuItems);
  } else {
    for (const item of adminDefaultMenuItems) {
      if (!item.userRoles || userOrganization.userRoles.some((r) => item.userRoles?.includes(r))) {
        defaultMenu.items.push(item);
      }
    }
  }

  return defaultMenu;
}
